import React from 'react';
import { foodCalculators } from './ConstantsFoodCalculator';
import SharedHelmet from '.././Helmet';

const TITLE = 'Calculatrices cuisine et nutrition gratuites';
const DESCRIPTION = 'Preparez vos recettes avec precision grace aux calculatrices de cuisine: conversion d ingredients, mesures, portions, pizza, gateaux et autres besoins culinaires.';
const KEYWORDS = 'calculatrice cuisine, conversion ingredients, calcul portions, mesures cuisson, calculatrice pizza, nutrition';
const OG_URL = 'https://do-calculate.com/fr/food-calculators/';

function FoodCalculatorsList() {
    return (
        <div className="container ltr-container">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
            <div>
                <h1 style={{ fontSize: '26px' }}>{TITLE}</h1>
                <hr />
                <div className="alert alert-info" role="alert">
                    <p>Des outils culinaires pratiques pour adapter vos recettes et gagner du temps en cuisine.</p>
                </div>
            </div>
            <hr />
            <table>
                <thead>
                    <tr>
                        <th>Calculatrice</th>
                        <th>Description</th>
                    </tr>
                </thead>
                <tbody>
                    {foodCalculators.map((calculator, index) => (
                        <tr key={index}>
                            <td>
                                <a href={calculator.link}> <h2 style={{ fontSize: '14px' }}>{calculator.name}</h2> </a>
                            </td>
                            <td><p>{calculator.description}</p></td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <br />
        </div>
    );
}

export default FoodCalculatorsList;
